import CloseIcon from "@mui/icons-material/Close";
import { clampIsoDateToToday, getReportDateInputProps } from "../../utils/reportDateLimits";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Backdrop,
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AppLoader from '../../components/AppLoader/AppLoader';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import XLSX, { boldRows } from "utils/xlsxStyled";
import eOpsLogo from "../../images/eops.png";
import { cfpBaseUrl } from "../../network/urls";
import { convertDatewithTime, getName } from "../../services/Functions";
import "../../style/common.scss";
import ReportExportButtons from "./components/ReportExportButtons";
import "./reportPageLayout.scss";
import "./ChangeOfAttributesStatusReport.scss";
import "./ChangeOfAttributesCancelApplicationReport.scss";
import {
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
import { resolveOfficeCodeForAdmin, getInitialAdminOfficeCode, getEffectiveAdminCompanyCode, resolveReportGoOfficeCode } from "../../utils/adminCompany";

const CANCEL_REPORT_COLUMNS = [
  { id: "SrNo", label: "Sr No" },
  { id: "applicationId", label: "Application ID" },
  { id: "creationDate", label: "Creation Date" },
  { id: "connectionAccountNo", label: "Connection Account No" },
  { id: "sanctionLoad", label: "Sanction Load" },
  { id: "tariff", label: "Tariff" },
  { id: "remarks", label: "Remarks" },
  { id: "lastModifiedBy", label: "Last Modified By" },
  { id: "lastModificationDate", label: "Last Modification Date" },
];

const ChangeOfAttributesCancelApplicationReport = () => {
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, selectedAdminCompanyCode } =
    useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode = code;
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState();
  const [officeName, setOfficeName] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

  // Pagination state
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [pageSizeInput, setPageSizeInput] = useState("20");
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  // Tracks whether a successful GO has been executed (to allow page-change refetch)
  const [hasSearched, setHasSearched] = useState(false);
  // Snapshot of filters at last GO — used for page navigation refetches
  const [appliedFilters, setAppliedFilters] = useState(null);

  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);

  useEffect(() => {
    if (String(code) !== "10") return;
    if (circleCode || selectedDivision || selectedSubDivision) return;
    const company = getEffectiveAdminCompanyCode(
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
    );
    if (company) {
      setOfficeCode(company);
    }
  }, [
    code,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  ]);

  const [dateFrom, setDateFrom] = useState(getTodayIsoDate());
  const [dateTo, setDateTo] = useState(getTodayIsoDate());
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);

  const OffLevel = String(offCode).length;
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  function getTodayIsoDate() {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  }

  const formatIsoDateForTitle = (value) => {
    if (!value) return "";
    const [year, month, day] = value.split("-");
    return `${day}-${month}-${year}`;
  };

  const getReportPeriodText = () => {
    if (dateFrom === dateTo) {
      return `Daily (${formatIsoDateForTitle(dateFrom)})`;
    }
    return `From ${formatIsoDateForTitle(dateFrom)} To ${formatIsoDateForTitle(dateTo)}`;
  };

  const getReportTitle = () => "COA Cancel Application";

  const getReportFilePrefix = () => "NC-Cancel-Application-Report";

  const getLogo = (code) => {
    switch (code) {
      case "10": return pitcLogo;
      case "11": return LESCOLOGO;
      case "12": return GEPCOLOGO;
      case "13": return FESCOLOGO;
      case "14": return IESCOLOGO;
      case "15": return MEPCOLOGO;
      case "26": return PESCOLOGO;
      case "27": return HAZECOLOGO;
      case "37": return HESCOLOGO;
      case "38": return SEPCOLOGO;
      case "48": return QESCOLOGO;
      case "59": return TESCOLOGO;
      default: return MEPCOLOGO;
    }
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10": return "Power Information Technology Company";
      case "11": return "Lahore Electric Supply Company";
      case "12": return "Gujranwala Electric Power Company";
      case "13": return "Faisalabad Electric Supply Company";
      case "14": return "Islamabad Electric Supply Company";
      case "15": return "Multan Electric Power Company";
      case "26": return "Peshawar Electric Supply Company";
      case "27": return "Hazara Electric Supply Company";
      case "38": return "Sukkur Electric Power Company";
      case "37": return "Hyderabad Electric Supply Company";
      case "48": return "Quetta Electric Supply Company";
      case "59": return "Tribal Electric Supply Company";
      default: return "";
    }
  };

  const formatCancelDate = (value) => {
    if (!value) return "";
    try {
      return convertDatewithTime(new Date(value));
    } catch {
      return value;
    }
  };

  const DownloadPdf = async (print) => {
    return new Promise((resolve) => {
      const offName = officeName;

      const pdfHeaders = [
        CANCEL_REPORT_COLUMNS.map((col) => ({ content: col.label })),
      ];

      let body = [];
      if (tableData && tableData.length > 0) {
        body = tableData.map((row) => [
          row.SrNo ?? "",
          row.applicationId ?? "",
          formatCancelDate(row.creationDate),
          row.connectionAccountNo ?? "",
          row.sanctionLoad ?? "",
          row.tariff ?? "",
          row.remarks ?? "",
          row.lastModifiedBy ?? "",
          formatCancelDate(row.lastModificationDate),
        ]);
      } else {
        body = [
          [
            {
              content: "No Data Found",
              colSpan: CANCEL_REPORT_COLUMNS.length,
              styles: {
                halign: "center",
                fontStyle: "bold",
                textColor: [153, 27, 27],
                fillColor: [254, 202, 202],
              },
            },
          ],
        ];
      }

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const isWideLogoCompany =
        companyCode === "12" || companyCode === "13" || companyCode === "11" ||
        companyCode === "16" || companyCode === "27" || companyCode === "48" ||
        companyCode === "59";
      const logoWidth = isWideLogoCompany ? 25 : 30;
      const logoHeight = isWideLogoCompany ? 20 : 10;

      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);
      pdf.addImage(eOpsLogo, "PNG", isWideLogoCompany ? 43 : 17, isWideLogoCompany ? 12 : 17, 20, 8);

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: "center" });
      pdf.text(getReportTitle(), pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(
        `${getReportTitle()} for ${offName} ${getReportPeriodText()}`,
        pageWidth / 2,
        25,
        { align: "center" }
      );

      pdf.autoTable({
        startY: 28,
        head: pdfHeaders,
        body,
        styles: { cellPadding: 1, fontSize: 7, halign: "center", lineWidth: 0.25, lineColor: "white" },
        theme: "striped",
        headStyles: { fillColor: [0, 106, 209], textColor: [255, 255, 255], halign: "center", valign: "middle" },
        bodyStyles: { halign: "center" },
        columnStyles: { 0: { halign: "left" }, 1: { halign: "left" }, 3: { halign: "left" } },
      });

      const numPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= numPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.text(`Page ${i} of ${numPages}`, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        const fileNameDatePart = dateFrom === dateTo ? dateFrom : `${dateFrom}-to-${dateTo}`;
        pdf.save(`${offName}-${fileNameDatePart}-${getReportFilePrefix()}.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportToExcel = () => {
    const offName = officeName;
    const excelHeaders = CANCEL_REPORT_COLUMNS.map((col) => col.label);
    const headingText = `${getReportTitle()} for ${offName} ${getReportPeriodText()}`;
    const finalData = [[headingText], excelHeaders];

    const body = tableData.map((row) => [
      row.SrNo ?? "",
      row.applicationId ?? "",
      formatCancelDate(row.creationDate),
      row.connectionAccountNo ?? "",
      row.sanctionLoad ?? "",
      row.tariff ?? "",
      row.remarks ?? "",
      row.lastModifiedBy ?? "",
      formatCancelDate(row.lastModificationDate),
    ]);

    finalData.push(...body);

    const ws = XLSX.utils.aoa_to_sheet(finalData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cancel Applications");

    const range = XLSX.utils.decode_range(ws["!ref"]);
    const columnCount = range.e.c - range.s.c + 1;
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }];
    ws["!rows"] = [{ hpx: 30 }, { hpx: 20 }];
    boldRows(ws, 1, 1);

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `${offName}-${dateFrom === dateTo ? dateFrom : `${dateFrom}-to-${dateTo}`}-${getReportFilePrefix()}.xlsx`
    );
  };

  const printPDF = async () => {
    const pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) document.body.removeChild(iframe);
      if (cancelButton.parentNode) document.body.removeChild(cancelButton);
    });
  };

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" };
        try {
          const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          }
        } catch {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" };
      try {
        const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        }
      } catch {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setIsLoading(false);
      }
    } else if (!selectedCompany) {
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value ? parseInt(event.target.value) : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" };
      try {
        const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);
            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find((c) => c.circleCode === selectedCircleCode);
            const cName = circle?.circleName || "";
            setOfficeName(cName.concat(" Circle"));
            setCircleName(cName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
                  acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        }
      } catch {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" };
      try {
        const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);
            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        }
      } catch {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find((c) => c.circleCode === selectedCircleCode);
      const cName = circle?.circleName || "";
      setOfficeName(cName.concat(" Circle"));
      setCircleName(cName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let offName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
          setOfficeName(offName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            setOfficeName(cscID);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            setOfficeName(cscID);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" };
      try {
        const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);
            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find((d) => d.divisionCode === selectedDivisionCode);
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
                  acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        }
      } catch {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName = filteredDivisions.find((d) => d.divisionCode === selectedDivisionCode)?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
            acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let offName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
      setOfficeName(offName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode == (circleCode ? circleCode : offCode))
        .reduce((acc, item) => {
          if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" };
      try {
        const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);
            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find((sub) => sub.subDivisionCode === selectedSubDivisionCode);
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        }
      } catch {
        setSubDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName = filteredSubDivisions.find((sub) => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let offName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
      setOfficeName(offName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(offCode, selectedCompanyCode, selectedAdminCompanyCode);
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }
          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          setOfficeName(cscID);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          setOfficeName(cscID);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          setOfficeName(cscID);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 5));
          setOfficeName(cscID);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (!acc.some((d) => d.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (hierarchy == 4 || cfcLevelId == 4 || hierarchy == 5 || cfcLevelId == 5) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
              acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  /**
   * Core data fetch. Uses filters snapshot when called from page-change;
   * uses current form state when called from GO button.
   */
  const fetchData = async ({ resolvedOfficeCode, df, dt, pg, ps }) => {
    setIsLoading(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      officeCode: resolvedOfficeCode,
      dateFrom: df,
      dateTo: dt,
      pageNumber: String(pg),
      pageSize: String(ps),
    });

    const requestOptions = { method: "POST", headers: myHeaders, body: raw, redirect: "follow" };

    try {
      const response = await fetch(cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesCancelReport", requestOptions);
      const result = await response.json();
      if (result.status === "200" && Array.isArray(result.data)) {
        setTableData(result.data);
        setTotalPages(Number(result.totalPages) || 0);
        setTotalRecords(Number(result.totalRecords) || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalRecords(0);
      }
    } catch {
      setTableData([]);
      setTotalPages(0);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  };

  const currentFilters = {
    OffLevel,
    officeCode,
    dateFrom,
    dateTo,
    selectedCompanyCode: code == 10 ? selectedCompanyCode : null,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }
    const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [OffLevel, officeCode, dateFrom, dateTo, selectedCompanyCode, circleCode, selectedDivision, selectedSubDivision]);

  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });

    const snapshot = { resolvedOfficeCode: reportOfficeCode, df: dateFrom, dt: dateTo };
    setAppliedFilters(snapshot);
    setPageNumber(1);
    setHasSearched(true);
    setLastAppliedFilters({ ...currentFilters });
    setIsGoDisabled(true);

    fetchData({ ...snapshot, pg: 1, ps: pageSize });
  };

  // Re-fetch when page or page size changes after initial GO
  useEffect(() => {
    if (!hasSearched || !appliedFilters) return;
    fetchData({ ...appliedFilters, pg: pageNumber, ps: pageSize });
  }, [pageNumber, pageSize]);

  const applyPageSize = (rawValue) => {
    const digitsOnly = String(rawValue ?? "").replace(/\D/g, "");
    const parsed = Number(digitsOnly);
    const nextSize = !digitsOnly || Number.isNaN(parsed) || parsed < 1 ? 1 : parsed;
    setPageSizeInput(String(nextSize));
    if (nextSize !== pageSize) {
      setPageSize(nextSize);
      setPageNumber(1);
    }
  };

  const handlePageSizeInputChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setPageSizeInput(digitsOnly);
  };

  const handlePageSizeInputBlur = () => {
    applyPageSize(pageSizeInput);
  };

  const handlePageSizeInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      applyPageSize(pageSizeInput);
    }
  };

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{ fontWeight: 600, color: "text.secondary", display: "block", mb: 0.5, lineHeight: 1.35 }}
    >
      {children}
    </Typography>
  );

  const tableCaptionText = `${getReportTitle()} for ${officeName} ${getReportPeriodText()}`;

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid container spacing={2} alignItems="flex-start" className="coa-filters-grid-wrap">
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="nccr-date-from">Date From</FilterFieldLabel>
          <TextField
            id="nccr-date-from"
            fullWidth size="small" variant="outlined" type="date"
            value={dateFrom}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateFrom(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="nccr-date-to">Date To</FilterFieldLabel>
          <TextField
            id="nccr-date-to"
            fullWidth size="small" variant="outlined" type="date"
            value={dateTo}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateTo(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="nccr-company">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select id="nccr-company" displayEmpty value={selectedCompanyCode || ""} onChange={handleChangeCompany}>
                <MenuItem value=""><em>Select Company</em></MenuItem>
                <MenuItem value="11">LESCO</MenuItem>
                <MenuItem value="12">GEPCO</MenuItem>
                <MenuItem value="13">FESCO</MenuItem>
                <MenuItem value="14">IESCO</MenuItem>
                <MenuItem value="15">MEPCO</MenuItem>
                <MenuItem value="26">PESCO</MenuItem>
                <MenuItem value="27">HAZECO</MenuItem>
                <MenuItem value="37">HESCO</MenuItem>
                <MenuItem value="38">SEPCO</MenuItem>
                <MenuItem value="48">QESCO</MenuItem>
                <MenuItem value="59">TESCO</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="nccr-circle">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="nccr-circle" displayEmpty
                value={circleCode === "" || circleCode === undefined || circleCode === null ? "" : circleCode}
                onChange={handleCircleChange}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value=""><em>All Circle</em></MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>{circle.circleName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="nccr-division">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="nccr-division" displayEmpty
                value={selectedDivision === "" || selectedDivision === undefined || selectedDivision === null ? "" : selectedDivision}
                onChange={handleDivisionChange}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value=""><em>All Division</em></MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem key={division.divisionCode} value={division.divisionCode}>{division.divisionName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="nccr-subdiv">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="nccr-subdiv" displayEmpty
                value={selectedSubDivision === "" || selectedSubDivision === undefined || selectedSubDivision === null ? "" : selectedSubDivision}
                onChange={handleSubDivisionChange}
                disabled={!selectedDivision}
                renderValue={(v) => renderSubDivisionValue(v, filteredSubDivisions)}
              >
                <MenuItem value=""><em>All Sub-Division</em></MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box aria-hidden sx={{ height: "1.35rem", mb: 0.5, lineHeight: 1.35 }} />
            <Button
              id="nccr-go-btn" fullWidth variant="contained" disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || isLoading}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const renderPagination = () => (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      spacing={1}
      sx={{ mt: 1.5, px: 1, justifyContent: "space-between" }}
      className="nccr-pagination"
    >
      <Typography variant="body2" color="text.secondary">
        Total Records: <strong>{totalRecords.toLocaleString()}</strong>
      </Typography>
      <Stack direction="row" alignItems="center" spacing={0.5} flexWrap="wrap">
        <Button size="small" variant="outlined" disabled={pageNumber <= 1 || isLoading} onClick={() => setPageNumber(1)}>
          First
        </Button>
        <Button size="small" variant="outlined" disabled={pageNumber <= 1 || isLoading} onClick={() => setPageNumber((p) => p - 1)}>
          Prev
        </Button>
        <Typography variant="body2" sx={{ px: 1 }}>
          Page <strong>{pageNumber}</strong> of <strong>{totalPages || 1}</strong>
        </Typography>
        <Button size="small" variant="outlined" disabled={pageNumber >= totalPages || isLoading} onClick={() => setPageNumber((p) => p + 1)}>
          Next
        </Button>
        <Button size="small" variant="outlined" disabled={pageNumber >= totalPages || isLoading} onClick={() => setPageNumber(totalPages)}>
          Last
        </Button>
        <TextField
          size="small"
          type="text"
          inputMode="numeric"
          className="nccr-page-size"
          value={pageSizeInput}
          onChange={handlePageSizeInputChange}
          onBlur={handlePageSizeInputBlur}
          onKeyDown={handlePageSizeInputKeyDown}
          disabled={isLoading}
          inputProps={{
            "aria-label": "Records per page",
            min: 1,
            style: { textAlign: "center", padding: "0 8px" },
          }}
          sx={{
            width: 72,
            "& .MuiOutlinedInput-root": {
              height: 30,
            },
            "& .MuiOutlinedInput-input": {
              height: 30,
              boxSizing: "border-box",
              fontSize: "0.78rem",
            },
          }}
        />
        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
          / page
        </Typography>
      </Stack>
    </Stack>
  );

  return (
    <>
      <Box className="form-box rpt-page coa-status-report coa-cancel-report-page">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">COA Cancel Application</h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{ p: 2, width: "100%", bgcolor: "#fff", borderRadius: 2, borderColor: "divider" }}
            >
              <div className={isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"}>
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to set dates and office, then tap <strong>GO</strong>.
                  </p>
                )}
              </div>

              <Stack
                direction="row" flexWrap="wrap" alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                spacing={1} className="coa-export-strip"
                sx={{ pt: 2, mt: 2, borderTop: "1px solid", borderColor: "divider", gap: 1 }}
              >
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton color="primary" onClick={() => setMobileFilterOpen(true)} aria-label="Open filters" size="small">
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button variant="contained" disableElevation className="coa-go-btn" size="small"
                    onClick={handleGoClick} disabled={isGoDisabled || isLoading}>
                    GO
                  </Button>
                )}
                <ReportExportButtons
                  isEmpty={tableData.length === 0}
                  onEmpty={noDataAvailable}
                  onPdf={() => DownloadPdf(true)}
                  onExcel={exportToExcel}
                  onPrint={printPDF}
                />
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          <Box className="application-table" sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
            <div className="div-datagrid">
              <div className="coa-table-panel">
                <div className="coa-table-scroll" id="pdf-table">
                  <table className="coa-data-table table" ref={tableRef}>
                    <thead>
                      <tr>
                        {CANCEL_REPORT_COLUMNS.map((col) => (
                          <th key={col.id} scope="col">{col.label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData && tableData.length > 0 ? (
                        tableData.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            <td>{row.SrNo ?? ""}</td>
                            <td>{row.applicationId ?? ""}</td>
                            <td>{formatCancelDate(row.creationDate)}</td>
                            <td>{row.connectionAccountNo ?? ""}</td>
                            <td>{row.sanctionLoad ?? ""}</td>
                            <td>{row.tariff ?? ""}</td>
                            <td>{row.remarks ?? ""}</td>
                            <td>{row.lastModifiedBy ?? ""}</td>
                            <td>{formatCancelDate(row.lastModificationDate)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr className="coa-empty-row">
                          <td colSpan={CANCEL_REPORT_COLUMNS.length}>No Data Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Box>

          {hasSearched && renderPagination()}

          <Drawer
            anchor="left" open={mobileFilterOpen} onClose={() => setMobileFilterOpen(false)}
            PaperProps={{ className: "coa-filter-drawer", sx: { width: { xs: "100%", sm: 400 }, maxWidth: "100vw", boxSizing: "border-box" } }}
          >
            <Box className="coa-drawer-inner" sx={{ p: 2, pb: 3, boxSizing: "border-box" }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Typography variant="h6" component="div">Filters</Typography>
                <IconButton aria-label="Close filters" onClick={() => setMobileFilterOpen(false)} edge="end" size="small">
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }} open={isLoading}>
        <AppLoader />
      </Backdrop>
    </>
  );
};

export default ChangeOfAttributesCancelApplicationReport;
